export const ROUTES_SESSION_REQUEST = '/session'
export const ROUTES_SESSION_MODULES_REQUEST = '/session/modules'
